import React, { useCallback, useEffect } from 'react';
import '../../../shared/contexts/TranslationContext.js';
import '../../../shared/contexts/StoreContext.js';
import '../../../shared/core/enums/GameSpecificTypes.js';
import '../../../shared/core/enums/MaxPayoutDataTypes.js';
import '../../../shared/core/enums/Chat.js';
import '../../../shared/core/enums/GameModes.js';
import '../../../shared/core/enums/IconTypes.js';
import '../../../shared/core/enums/BetStatus.js';
import '../../../shared/core/enums/PopupTypes.js';
import '../../../shared/core/enums/ApiVersion.js';
import '../../../shared/core/enums/RoundStatus.js';
import '../../../shared/core/enums/FreeBetsStatus.js';
import '../../../shared/core/enums/SocketEvents.js';
import '../../../shared/core/enums/TranslationKeys.js';
import '../../../shared/core/enums/TimeoutMaxValue.js';
import '../../../shared/core/enums/ApiServiceTypes.js';
import '../../../shared/core/enums/EnvironmentTypes.js';
import '../../../shared/core/enums/DefaultQueryValues.js';
import '../../../shared/core/enums/FreeBetWinningType.js';
import '../../../shared/core/enums/DefaultQueryParams.js';
import '../../../shared/core/enums/BetHistoryFilterTypes.js';
import '../../../shared/core/enums/GameThemeTypes.js';
import '../../../shared/core/enums/RequestStatus.js';
import '../../../shared/core/enums/FetchDefaultPaths.js';
import '../../../shared/core/enums/ResponseCodes.js';
import { isMobile } from '../../../shared/core/helpers/isMobile.js';
import '../../../_tslib-7a01aab4.js';
import { z as freeBetStore } from '../../../validateBalanceOnBet-af4f4a9b.js';
import '../../../shared/core/store/chatStore.js';
import '../../../shared/core/store/wageringStore.js';
import '../../../shared/core/store/roundInfoStore.js';
import '../../../shared/core/store/userCountStore.js';
import '../../../shared/core/store/gameResultStore.js';
import '../../../shared/core/store/resultHashStore.js';
import '../../../shared/core/store/userWinBetsStore.js';
import '../../../shared/core/store/notificationStore.js';
import '../../../shared/core/store/selectedResultInfoStore.js';
import '../../../shared/core/store/forCrashGame/inputValidationStore.js';
import '../../../shared/core/store/forCrashGame/totalBetStore.js';
import '../../../shared/core/store/forCrashGame/resultReportStore.js';
import '../../../shared/core/store/forCrashGame/gameStore.js';
import '../../../shared/core/services/liveConnection/types.js';
import 'axios';
import '../../../shared/core/services/sound/types.js';
import '../../../shared/core/services/sound/SoundService.js';
import '../../../shared/core/services/sound/defaultSounds.js';
import '../../../shared/core/services/api/types.js';
import '../../../shared/core/services/ApiServices.js';
import '../../../momentFormat-e9197995.js';
import '../../../shared/core/polyfill.js';
import 'react-router-dom';
import { usePopupStore } from '../../../shared/hooks/usePopUpStore.js';
import '../../../shared/core/enums/additionalInputValueChangingButtons.js';
import '../../../shared/providers/storeProvider.js';
import { UnderMaintenanceContainer } from '../../../shared/containers/underMaintenanceContainer/index.js';
import '../../../shared/containers/platformMessagesWrapper/index.js';
import { ax as FreeChipsWinPopup } from '../../../index-8d2f08b7.js';
import '../../../shared/containers/localStoragePupUpWrapper/index.js';
import '../../../shared/containers/gameDrawingWrapper/index.js';
import '../../../shared/containers/renderOdd/index.js';
import '../../../shared/components/user-block/user-block-free-bet/index.js';
import '../../../shared/components/game-type-loading/index.js';
import { PopUps } from '../../t_types/enums/PopupTypes.js';
import { WebLobby } from './webLobby.js';
import { MobileLobby } from './mobileLobby.js';
import 'mobx';
import '../../../shared/core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../shared/core/enums/BogLineGameConfig.js';
import '../../../shared/core/helpers/parseQuery.js';
import '../../../shared/core/enums/StatisticsSortingTypes.js';
import '../../../shared/core/services/api/BaseApiService.js';
import '../../../shared/core/helpers/deepCopy.js';
import '../../t_types/enums/BetResponseCode.js';
import '../../t_types/enums/BetErrorMessages.js';
import '../../t_types/enums/NotificationByResponseCode.js';
import '../../t_types/enums/FreeChipTypes.js';
import '../../../shared/core/helpers/formatDate.js';
import '../../../shared/core/enums/bogGameNames.js';
import '../../../shared/core/helpers/updateHalfBets.js';
import 'howler';
import '../../../_commonjsHelpers-17aad09c.js';
import 'mobx-react-lite';
import '../../../index-e609ebf3.js';
import '../../../shared/core/helpers/getAmountWithCurrency.js';
import '../../../shared/core/enums/Currencies.js';
import '../../../shared/hooks/useTranslation.js';
import '../../../shared/core/helpers/setTranslationValues.js';
import '../../table-components/lobby/web/lobbyRoomWinner/index.js';
import '../../../shared/core/helpers/maskName.js';
import '../../../shared/core/helpers/exchangeAmountByRate.js';
import '../../../shared/core/helpers/getDataHelper.js';
import '../../../shared/core/helpers/rtlCheckerAndSetter.js';
import '../../../shared/hooks/useAssetsLoadedState.js';
import '../../../shared/hooks/useDisableFullScreenShortcuts.js';
import '../../table-components/lobby/web/slider/index.js';
import '../../../shared/core/helpers/convertAmount.js';
import '../../../shared/core/helpers/getLocaleTime.js';
import '../../../shared/components/free-bets/free-bet-info/index.js';
import '../../../shared/components/free-bets/free-bets-list/index.js';
import '../../../shared/hooks/useClickOutside.js';
import '../../../bog-line/components/snowFlakes/index.js';
import '../../../bog-line/components/grids/common/pop-up-wr-component/index.js';
import '../../../bog-line/components/list/list-item-with-image/index.js';
import '../../../bog-line/components/list/list/index.js';
import '../../../bog-line/components/list/list-header/index.js';
import '../../../bog-line/components/list/list-item-header/index.js';
import '../../../bog-line/components/list/list-body/index.js';
import '../../../bog-line/components/loading/component/index.js';
import '../../../bog-line/components/loading/logo/index.js';
import '../../../bog-line/components/loading/progress/index.js';
import '../../../bog-line/components/loading/provider/index.js';
import '../../../bog-line/components/loading/loader-content/index.js';
import 'react-dom';
import '../../../bog-line/components/popups/aboutHash.js';
import '../../../shared/core/helpers/copyToClipboard.js';
import '../../../shared/hooks/useOpenBetHistory.js';
import '../../../bog-line/components/grids/common/column-body-inner/index.js';
import '../../../bog-line/components/grids/common/column-body-inner-bottom-wr/index.js';
import '../../../bog-line/components/grids/common/column-body-inner-top-wr/index.js';
import '../../../bog-line/components/tabs/tabs/index.js';
import '../../../bog-line/components/tabs/tab-item/index.js';
import '../../../bog-line/components/grids/common/column-header-block/index.js';
import '../../../bog-line/components/grids/common/column-header-block-inner/index.js';
import '../../../bog-line/components/icon-block/index.js';
import '../../../shared/core/helpers/isIOS.js';
import '../../../shared/hooks/useOutsideClick.js';
import '../../../bog-line/components/grids/common/column-header/index.js';
import '../../../bog-line/components/chat/chatActions/index.js';
import '../../../shared/containers/horizontalScrollWrapper/index.js';
import '../../../bog-line/components/chat/chatLoader/index.js';
import '../../../bog-line/components/dots-loader/index.js';
import '../../../bog-line/components/list/list-header-filter/index.js';
import '../../../bog-line/components/list/list-item-header-filter/index.js';
import '../../../bog-line/components/grids/web/game/column/index.js';
import '../../../bog-line/components/grids/web/game/column-inner/index.js';
import '../../../bog-line/components/grids/web/game/column-middle-wr/index.js';
import '../../../bog-line/components/grids/web/game/column-header-wr/index.js';
import '../../../bog-line/components/user-block/user-info/index.js';
import '../../../bog-line/components/user-block/user-content/index.js';
import '../../../bog-line/components/play-for-real-button/index.js';
import '../../../bog-line/components/grids/web/game/column-body/index.js';
import '../../../shared/core/helpers/checkScrollToBottom.js';
import '../../../shared/core/enums/GameSceneCodes.js';
import '../../../bog-line/components/navigation/nav-item/index.js';
import '../../../bog-line/components/navigation/nav-row/index.js';
import '../../../bog-line/components/grids/mobile/game/main-cont/index.js';
import '../../../bog-line/components/grids/mobile/game/column/index.js';
import '../../../bog-line/components/notifications/connection-pop-up/index.js';
import '../../../shared/core/helpers/generateUId.js';
import '../../../shared/containers/bettingPart/numPadWr.js';
import '../../../shared/containers/bettingPart/betingPartAvia.js';
import '../../../shared/containers/bettingPart/autoBet/index.js';
import '../../../shared/containers/bettingPart/betamount/index.js';
import '../../../shared/hooks/useInputValueChangingFunctions.js';
import '../../../shared/containers/bettingPart/autoCashOut/index.js';
import '../../../shared/core/helpers/checkMaxAutoCashOutValue.js';
import '../../../shared/hooks/useAmountValidation.js';
import '../../../shared/containers/bettingPart/quickBetamountButtons/index.js';
import '../../../shared/core/helpers/quickBetAmount.js';
import '../../../shared/containers/bettingPart/betButton/index.js';
import '../../../shared/containers/bettingPart/betButton/halfCashOut.js';
import '../../../shared/containers/bettingPart/betButton/betButton.js';
import '../../../shared/containers/bettingPart/betButton/accumulatedPossibleWin.js';
import '../../../shared/containers/bettingPart/autoBet/autoBetPopUp/index.js.js';
import '../../table-components/header/web/logoImg/index.js';
import '../../table-components/notification/notification-type-component/index.js';
import '../../table-components/notification/notification-wr/index.js';
import '../../../shared/containers/fullScreenWrapper/index.js';
import '../../../shared/hooks/useFullScreen.js';
import '../../table-components/footer/web/footerUserInfoColumn/index.js';
import '../../table-components/loading/index.js';
import '../../table-components/lobbyLoadingInfoWr/index.js';
import '../../table-components/setting/settingRowColumn/index.js';
import '../../table-components/rightSide/rightSideIcon/index.js';
import '../../table-components/rightSide/mobileNavigationRow/index.js';
import '../../table-components/accordion/accordionItem.js';
import '../../table-components/accordion/context.js';
import '../../../shared/core/helpers/cleanGameTypeIdFromQuery.js';
import '../../../shared/hooks/useLobbyStore.js';
import '../../../shared/hooks/useUserInfoStore.js';
import '../../table-components/lobby/web/settingsButton/index.js';
import '../../table-components/header/web/headerWr/index.js';
import '../../table-components/header/web/headerColumn/index.js';
import '../../table-components/header/web/fairnessButton/index.js';
import '../../t_types/enums/GameControllerTypes.js';
import '../../table-components/gameController/gameControllersWr/index.js';
import '../../table-components/gameController/gameControllersHead/index.js';
import '../../table-components/gameController/gameControllersContent/index.js';
import '../../../shared/core/enums/gameControllerTypes.js';
import '../../table-components/gameController/gameControllersFooter/index.js';
import '../../../shared/hooks/useRoundInfoStore.js';
import '../../../shared/hooks/useUserCountStore.js';
import '../../../shared/hooks/useApplicationStore.js';
import '../../table-components/grids/mobile/structureBottom/index.js';
import '../../table-components/footer/mobile/footer-wr/index.js';
import '../../table-components/footer/mobile/footer-column/index.js';
import '../../table-components/footer/mobile/userBalanceAndTotalBet/index.js';
import '../../table-components/footer/web/footerInfoSpan/index.js';
import '../../table-components/footer/web/footerInfo/index.js';
import '../../table-components/footer/web/footerColumn/index.js';
import '../../table-components/footer/web/footerUserInfo/index.js';
import '../../table-components/footer/web/footerContainer/index.js';
import '../../table-components/footer/web/userBalanceAndTotalBetAmount/index.js';
import '../../table-components/footer/web/playForRealButtonHolder/index.js';
import '../../table-components/setting/settingWr/index.js';
import '../../table-components/setting/settingRow/index.js';
import '../../table-components/overlay/overlayLabel/index.js';
import '../../table-components/overlay/overlayLabels/index.js';
import '../../table-components/overlay/overlayListWr/index.js';
import '../../table-components/overlay/overlayItem/index.js';
import '../../table-components/overlay/overlayItemContent/index.js';
import '../../table-components/overlay/overlayFooter/index.js';
import '../../table-components/grids/mobile/structureTop/index.js';
import '../../table-components/header/mobile/gameId/index.js';
import '../../table-components/header/mobile/headerWr/index.js';
import '../../table-components/header/mobile/headerLogo/index.js';
import '../../table-components/header/mobile/headerColumn/index.js';
import '../../table-components/header/mobile/fairnessButton/index.js';
import '../../table-components/header/mobile/playForRealButtonHolder/index.js';
import '../../../shared/core/helpers/abbreviateNumber.js';
import '../../table-components/header/mobile/minMaxBet/index.js';
import '../../table-components/notification/connectionPopUp/index.js';
import '../../../shared/hooks/useSelectedResultInfoStore.js';
import '../../../shared/hooks/useInfiniteScroll.js';
import '../../table-components/accordion/accordion.js';
import '../../../shared/core/helpers/translateMonth.js';
import '../../../shared/core/enums/BogLineGameConfigs.js';
import '../../../shared/core/helpers/gameDrawingSupportersFunctions.js';
import '../../table-components/lobby/web/lobbyWr/index.js';
import '../../table-components/lobby/web/lobbyHeader/index.js';
import '../../table-components/lobby/web/lobbyFooter/index.js';
import '../../table-components/lobby/web/lobbySection/index.js';
import '../../table-components/lobby/mobile/lobbyWr/index.js';
import '../../table-components/lobby/mobile/lobbySection/index.js';

var TableLobby = function (_a) {
    var bgVideo = _a.bgVideo, hasVideo = _a.hasVideo, gameLogo = _a.gameLogo, slidersData = _a.slidersData, slideDuration = _a.slideDuration, lobbyRoomImages = _a.lobbyRoomImages, isShowRoundState = _a.isShowRoundState, currentWinnersImg = _a.currentWinnersImg, isShowGameTypeName = _a.isShowGameTypeName, hasFreeBets = _a.hasFreeBets, freeBetRedirectGameTypeId = _a.freeBetRedirectGameTypeId, freeBetRedirectInGamePath = _a.freeBetRedirectInGamePath;
    var open = usePopupStore().open;
    var activeFreeBet = freeBetStore.activeFreeBet, resetActiveFreeBet = freeBetStore.resetActiveFreeBet;
    var openHelpPopUp = useCallback(function () {
        open({ name: PopUps.Help });
    }, [open]);
    useEffect(function () {
        if (activeFreeBet.id) {
            resetActiveFreeBet();
        }
    }, []);
    return (React.createElement(UnderMaintenanceContainer, null,
        React.createElement(React.Fragment, null,
            isMobile() ? (React.createElement(MobileLobby, { hasVideo: hasVideo, gameLogo: gameLogo, isShowRoundState: isShowRoundState, lobbyRoomImages: lobbyRoomImages, isShowGameTypeName: isShowGameTypeName, hasFreeBets: hasFreeBets, freeBetRedirectGameTypeId: freeBetRedirectGameTypeId, freeBetRedirectInGamePath: freeBetRedirectInGamePath })) : (React.createElement(WebLobby, { bgVideo: bgVideo, gameLogo: gameLogo, hasVideo: hasVideo, slidersData: slidersData, openHelpPopup: openHelpPopUp, isShowRoundState: isShowRoundState, lobbyRoomImages: lobbyRoomImages, currentWinnersImg: currentWinnersImg, isShowGameTypeName: isShowGameTypeName, slideDuration: slideDuration, hasFreeBets: hasFreeBets, freeBetRedirectGameTypeId: freeBetRedirectGameTypeId, freeBetRedirectInGamePath: freeBetRedirectInGamePath })),
            React.createElement(FreeChipsWinPopup, null))));
};

export { TableLobby };
